var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('add')}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }